import React, { useState, useEffect, useReducer, useCallback } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AddIcon from '@mui/icons-material/Add'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormLabel from '@mui/material/FormLabel'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { uploadFileData } from '../../actions/userActions'
import { closePopup } from '../../actions/uiActions'
import {
    getDataSources,
    saveDataToolsJob,
    dataToolsGetDimensions,
    dataToolsGetDimensionMembers,
    readColumnsFromZipEntry,
    dataToolsGetDimensionsComparison,
    dataToolsDeleteBlobsFromUnfinishedJob,
    readTablesFromExcel,
    readTablesFromExcelFiles,
    getTransformData,
    dataToolsGetMeasureAggregations,
    getProjects
} from '../../actions/dbFunctionsActions'
import AddTaskList, { ALL_ACTIONS } from '../ui/tasks/AddTaskList'

function DataToolsTaskList(props) {
    const DB_JOB_TYPE = 2
    const MODE_NONE = ''
    const MODE_ADD = 'add'
    const MODE_EDIT = 'edit'

    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [savingJob, setSavingJob] = useState(false)
    const [sqLDbList, setSqLDbList] = useState([])
    const [ssisJobs, setSsisJobs] = useState([])
    const [mode, setMode] = useState(MODE_NONE)
    const [jobTasks, setJobTasks] = useState([])
    const [currentTask, setCurrentTask] = useState({})
    const [taskIndex, setTaskIndex] = useState(-1)
    const [currentJobId, setCurrentJobId] = useState(-1)
    const [currentJobName, setCurrentJobName] = useState('')
    const [currentJobDescription, setCurrentJobDescription] = useState('')
    const [taskValidated, setTaskValidated] = useState([])
    const [filesPresaved, setFilesPresaved] = useState([])
    const [globalFiles, setGlobalFiles] = useState([])
    const [projectId, setProjectId] = useState(-1)
    const [projectList, setProjectList] = useState([])
    const [header, setHeader] = useState('Create Job')
    const [, forceUpdate] = useReducer(x => x + 1, 0)
    const [projectError, setProjectError] = useState(false)
    const [jobNameError, setJobNameError] = useState(false)
    const [pendingProjectId, setPendingProjectId] = useState(null)
    const [confirmProjectChangeOpen, setConfirmProjectChangeOpen] = useState(false)

    // True only when creating a brand-new job (not editing an existing one)
    const isAddingNewJob = props.popupInfo.jobData === null
    // Controls are locked only during new-job creation until a project is chosen
    const isDisabled = isAddingNewJob && projectId === -1

    useEffect(() => {
        setSqLDbList(props.popupInfo.databases)
        setSsisJobs(props.popupInfo.packages)

        if (props.popupInfo.jobData !== null) {
            setHeader('Edit Job')
            let jobData = JSON.parse(props.popupInfo.jobData.jobData)
            let newSteps = []
            let validated = []

            for (let x = 0; x < jobData.Tasks.length; x++) {
                for (let y = 0; y < ALL_ACTIONS.length; y++) {
                    if (ALL_ACTIONS[y]["key"] === jobData.Tasks[x]["Key"]) {
                        newSteps.push({ mode: ALL_ACTIONS[y]["name"], data: jobData.Tasks[x]["Value"] })
                        validated.push(ALL_ACTIONS[y].validateControl(jobData.Tasks[x]["Value"]))
                    }
                }
            }

            if (jobData.Files && jobData.Files.length > 0) {
                setFilesPresaved(jobData.Files)
            }

            setCurrentJobId(props.popupInfo.jobData.id)
            setCurrentJobName(props.popupInfo.jobData.jobName)
            setCurrentJobDescription(props.popupInfo.jobData.jobDescription)
            setJobTasks(newSteps)
            setTaskValidated(validated)

            setProjectId(props.popupInfo.jobData.projectId)

        } else {
            setHeader('Create Job')
            setMode(MODE_ADD)

            getProjects().then(json => {
                setProjectList(json.projectList || [])
            }).catch(ex => {
                console.error('Failed to load projects', ex)
                setProjectList([])
            })
        }

        if (props.popupInfo.globalFiles && props.popupInfo.globalFiles.length > 0) {
            setGlobalFiles(props.popupInfo.globalFiles)
        }

    }, [])

    function applyProjectChange(newProjectId) {
        setProjectId(newProjectId)
        setProjectError(false)
        setJobTasks([])
        setTaskValidated([])
        setTaskIndex(-1)
        setMode(MODE_ADD)
        setCurrentTask({})
    }

    function handleProjectChange(e) {
        const newProjectId = parseInt(e.target.value)
        if (jobTasks.length > 0) {
            setPendingProjectId(newProjectId)
            setConfirmProjectChangeOpen(true)
        } else {
            applyProjectChange(newProjectId)
        }
    }

    function handleConfirmProjectChange() {
        applyProjectChange(pendingProjectId)
        setPendingProjectId(null)
        setConfirmProjectChangeOpen(false)
    }

    function handleCancelProjectChange() {
        setPendingProjectId(null)
        setConfirmProjectChangeOpen(false)
    }

    function getJobStepId(stepMode) {
        for (let x = 0; x < ALL_ACTIONS.length; x++) {
            if (ALL_ACTIONS[x]["name"] === stepMode) {
                return ALL_ACTIONS[x]["key"]
            }
        }
        return 2
    }

    function removeStepAtIndex(index) {
        let copiedSteps = []
        let copiedValidated = []

        for (let x = 0; x < jobTasks.length; x++) {
            if (x !== index) {
                copiedSteps.push(jobTasks[x])
                copiedValidated.push(taskValidated[x])
            }
        }

        setJobTasks(copiedSteps)
        setTaskValidated(copiedValidated)
        setTaskIndex(-1)
        setMode(MODE_NONE)
    }

    function swapTaskIndex(index, newIndex) {
        console.log("swapTaskIndex", index, newIndex)
        let copiedSteps = []
        let copiedValidated = []

        for (let x = 0; x < jobTasks.length; x++) {
            copiedSteps.push(jobTasks[x])
            copiedValidated.push(taskValidated[x])
        }

        const taskInOldIndex = JSON.parse(JSON.stringify(copiedSteps[index]));
        const taskInNewIndex = JSON.parse(JSON.stringify(copiedSteps[newIndex]));
        copiedSteps[index] = taskInNewIndex
        copiedSteps[newIndex] = taskInOldIndex

        const taskInOldValidatedIndex = JSON.parse(JSON.stringify(copiedValidated[index]));
        const taskInNewValidatedIndex = JSON.parse(JSON.stringify(copiedValidated[newIndex]));
        copiedValidated[index] = taskInNewValidatedIndex
        copiedValidated[newIndex] = taskInOldValidatedIndex

        setJobTasks(copiedSteps)
        setTaskValidated(copiedValidated)
        setTaskIndex(newIndex)
    }

    function handleClick(event) {
        event.preventDefault()

        if (currentJobId === -1 && filesPresaved.length > 0 && !savingJob) {
            let blobFiles = []
            for (let x = 0; x < filesPresaved.length; x++) {
                blobFiles.push(filesPresaved[x]["blobName"])
            }
            props.dataToolsDeleteBlobsFromUnfinishedJob()
        }

        props.closePopup()
    }

    function handleJobStepsSave(event) {
        event.preventDefault()

        if (currentJobId === -1 && projectId === -1) {
            setProjectError(true)
            return
        }

        if (!currentJobName.trim()) {
            setJobNameError(true)
            return
        }

        let taskList = { "Files": filesPresaved, "Tasks": [] }
        setSavingJob(true)
        setIsLoadingRequest(true)

        for (let x = 0; x < jobTasks.length; x++) {
            taskList.Tasks.push({ "Key": getJobStepId(jobTasks[x]["mode"]), "Value": jobTasks[x]["data"] })
        }

        props.saveDataToolsJob(DB_JOB_TYPE, JSON.stringify(taskList), currentJobId, currentJobName, currentJobDescription, projectId)
        setIsLoadingRequest(false)
    }

    function renderSubmitButton() {
        if (isLoadingRequest) {
            return <button type="submit" className="btn" disabled onClick={() => { }}>Saving...</button>
        }

        if (isDisabled) {
            return <button type="submit" className="btn" disabled onClick={() => { }}>Save Job</button>
        }

        let allTasksValid = true

        if (jobTasks.length === 0) {
            allTasksValid = false
        } else {
            for (let taskIterator = 0; taskIterator < jobTasks.length; taskIterator++) {
                for (let x = 0; x < ALL_ACTIONS.length; x++) {
                    if (ALL_ACTIONS[x]["name"] === jobTasks[taskIterator].mode) {
                        let validated = ALL_ACTIONS[x].validateControl(jobTasks[taskIterator].data)
                        if (!validated) {
                            allTasksValid = false
                        }
                    }
                }
            }
        }

        if (allTasksValid) {
            return <button type="submit" className="btn" onClick={handleJobStepsSave}>Save Job</button>
        } else {
            return <button type="submit" className="btn" disabled onClick={() => { }}>Job Is Invalid</button>
        }
    }

    function renderLeftPanelButton(task, index) {
        let foundMatch = false
        let icon = null
        let text = null
        let validated = null
        let isSelected = index === taskIndex

        for (let x = 0; x < ALL_ACTIONS.length; x++) {
            if (ALL_ACTIONS[x]["name"] === task.mode) {
                foundMatch = true
                icon = ALL_ACTIONS[x]["icon"]
                text = ALL_ACTIONS[x]["text"]
                validated = ALL_ACTIONS[x].validateControl(task.data)
            }
        }

        if (foundMatch) {
            return (<ListItemButton
                disabled={isDisabled}
                style={isSelected ? { "backgroundColor": "rgba(0, 0, 0, 0.2)" } : {}}
                onClick={() => {
                    setCurrentTask(task)
                    setMode(MODE_EDIT)
                    setTaskIndex(index)
                }}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={text} primaryTypographyProps={{ style: { color: (validated) ? "#000" : "#d32f2f" } }} />
            </ListItemButton>)
        } else {
            return null
        }
    }

    function renderRightPanel() {
        if (mode === MODE_ADD) {
            return <AddTaskList onSelect={(mode) => {
                let copied = jobTasks
                let copiedValidated = taskValidated

                copied.push({ mode: mode.name, data: mode.emptyDataItem })
                copiedValidated.push(false)

                setJobTasks(copied)
                setTaskValidated(copiedValidated)

                setCurrentTask({ mode: mode.name, data: mode.emptyDataItem })
                setMode(MODE_EDIT)
                setTaskIndex(copied.length - 1)
            }} />
        } else if (mode === MODE_EDIT) {
            let renderLogicStep = null
            let foundActionIndex = -1

            for (let x = 0; x < ALL_ACTIONS.length; x++) {
                if (ALL_ACTIONS[x]["name"] === currentTask.mode) {
                    renderLogicStep = ALL_ACTIONS[x]
                    foundActionIndex = x
                }
            }

            if (renderLogicStep !== null) {

                return renderLogicStep.renderMainComponent(
                    taskIndex,
                    filesPresaved.concat(
                        globalFiles
                            .filter(f => f["projectId"] === projectId)
                            .map(f => JSON.parse(f["jobFileData"]))
                    ),
                    currentTask.data,
                    sqLDbList,
                    ssisJobs,
                    props.getDataSources,
                    props.dataToolsGetDimensions,
                    props.dataToolsGetDimensionMembers,
                    props.readColumnsFromZipEntry,
                    props.dataToolsGetDimensionsComparison,
                    props.readTablesFromExcel,
                    props.readTablesFromExcelFiles,
                    props.getTransformData,
                    props.dataToolsGetMeasureAggregations,
                    (data) => {
                        for (let x = 0; x < jobTasks.length; x++) {
                            if (x === taskIndex) {
                                jobTasks[x]["data"] = data
                                taskValidated[x] = ALL_ACTIONS[foundActionIndex].validateControl(data)
                                forceUpdate()
                            }
                        }
                    })
            } else {
                return null
            }
        } else {
            return <h3>Task Infomation Found Here</h3>
        }
    }

    function removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }

    function shouldUpArrayBeEnabled(currentlySelectedIndex, allJobTasks) {
        if (allJobTasks.length > 1 && currentlySelectedIndex > 0) {
            return false
        }
        return true
    }

    function shouldDownArrayBeEnabled(currentlySelectedIndex, allJobTasks) {
        if (allJobTasks.length > 1 && currentlySelectedIndex < (allJobTasks.length - 1) && currentlySelectedIndex !== -1) {
            return false
        }
        return true
    }

    return (<>
        <Dialog
            maxWidth={"lg"}
            fullWidth={true}
            open={true}
            fullScreen={false}
            onClose={handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="datatools2"
        >
            <CloseIcon onClick={handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">
                {header}
                {' '}
            </DialogTitle>
            <DialogContent>
                <form className="form dbFunctions">
                    {currentJobId === -1 && (
                        <div className="field">
                            <FormLabel component="legend" error={projectError}>Select Project</FormLabel>
                            <Select
                                className="myInput"
                                value={projectId}
                                error={projectError}
                                onChange={handleProjectChange}
                                inputProps={{ 'aria-label': 'Without label' }}
                                displayEmpty
                            >
                                {projectList.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>{x.projectName}</MenuItem>
                                ))}
                            </Select>
                            <p style={{ color: '#d32f2f', margin: '4px 0 0', fontSize: '0.75rem', visibility: isDisabled ? 'visible' : 'hidden' }}>
                                Please select project first
                            </p>
                        </div>
                    )}
                    <div className="field">
                        <TextField
                            fullWidth
                            label="Job Name"
                            variant="outlined"
                            value={currentJobName}
                            disabled={isDisabled}
                            error={jobNameError}
                            helperText={jobNameError ? 'Job name is required.' : ''}
                            onChange={(e) => {
                                e.preventDefault()
                                setCurrentJobName(e.target.value)
                                if (e.target.value.trim()) setJobNameError(false)
                            }} />
                    </div>
                    <div className="field">
                        <TextField
                            fullWidth
                            label="Job Description"
                            variant="outlined"
                            value={currentJobDescription}
                            disabled={isDisabled}
                            onChange={(e) => { e.preventDefault(); setCurrentJobDescription(e.target.value); }} />
                    </div>
                    <div className="field" style={{ color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : 'inherit' }}>
                        Add Task
                        <IconButton disabled={isDisabled} onClick={() => setMode(MODE_ADD)}><AddIcon /></IconButton>
                    </div>
                    <div className="field">
                        <Grid container spacing={2}>
                            <Grid item xs={4} style={{ "maxHeight": "500px", "overflowY": "auto", "border": "1px solid #D3D3D3" }}>
                                <h3 style={{ color: isDisabled ? 'rgba(0, 0, 0, 0.38)' : 'inherit' }}>
                                    Current Steps In Job
                                    <IconButton disabled={isDisabled || shouldUpArrayBeEnabled(taskIndex, jobTasks)} onClick={() => swapTaskIndex(taskIndex, taskIndex - 1)}><ArrowUpwardIcon /></IconButton>
                                    <IconButton disabled={isDisabled || shouldDownArrayBeEnabled(taskIndex, jobTasks)} onClick={() => swapTaskIndex(taskIndex, taskIndex + 1)}><ArrowDownwardIcon /></IconButton>
                                </h3>
                                <List>
                                    {jobTasks.map((x, i) => {
                                        return (<ListItem
                                            key={`step-${i}`}
                                            secondaryAction={
                                                <IconButton edge="end" aria-label="comments" disabled={isDisabled} onClick={() => {
                                                    removeStepAtIndex(i)
                                                }}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            }>
                                            {renderLeftPanelButton(x, i)}
                                        </ListItem>)
                                    })}
                                </List>
                            </Grid>
                            <Grid item xs={8} style={{ "maxHeight": "500px", "overflowY": "auto", "border": "1px solid #D3D3D3" }}>
                                <div style={isDisabled ? { pointerEvents: 'none', opacity: 0.38 } : {}}>
                                    {renderRightPanel()}
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="field">
                        {renderSubmitButton()}
                    </div>
                </form>
            </DialogContent>
        </Dialog>
        <Dialog
            open={confirmProjectChangeOpen}
            onClose={handleCancelProjectChange}
            aria-labelledby="confirm-project-change-title"
            aria-describedby="confirm-project-change-description"
        >
            <DialogTitle id="confirm-project-change-title">Change Project</DialogTitle>
            <DialogContent>
                <DialogContentText id="confirm-project-change-description">
                    Changing project will reset all selected tasks. Do you want to proceed?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancelProjectChange}>Cancel</Button>
                <Button onClick={handleConfirmProjectChange} variant="contained" color="error">Proceed</Button>
            </DialogActions>
        </Dialog>
    </>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        role: state.users.role,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({
            closePopup,
            getDataSources,
            saveDataToolsJob,
            dataToolsGetDimensions,
            dataToolsGetDimensionMembers,
            uploadFileData,
            readColumnsFromZipEntry,
            dataToolsGetDimensionsComparison,
            dataToolsDeleteBlobsFromUnfinishedJob,
            readTablesFromExcel,
            readTablesFromExcelFiles,
            getTransformData,
            dataToolsGetMeasureAggregations
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataToolsTaskList)